/**
 * Created by ccg
 * Date 2019/1/2
 */

import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import request from '@/utils/request';
import projectDetailAPI from '@/api/projectDetail';
import projectApi from '@/api/project';
import panelApi from '@/api/panel';
import {
  COMPONENT_TYPE, COM_SEND_TYPE, PANEL_STATUS, PROJECT_NODE_TYPE,
} from '@/common/enums';
import websocketApi from '@/api/websocketApi';
import * as Types from './mutations-types';

export default {
  // 点击删除组件
  deleteCpt({ state, dispatch }, payload) {
    const { index } = payload;
    if (index === undefined) {
      return;
    }
    const componentId = state.panelDataCcg[index].cid;
    state.panelDataCcg.splice(index, 1);
    dispatch('deleteNotify', { componentId });
    dispatch('saveAllCpt');
  },
  deleteCpts({ state, commit, dispatch }, payload) {
    const { cidList } = payload;
    // console.log(cidList);
    const indexList = [];
    for (let i = 0; i < cidList.length; i += 1) {
      const componentId = cidList[i];
      for (let j = 0; j < state.panelDataCcg.length; j += 1) {
        if (componentId === state.panelDataCcg[j].cid) {
          indexList.push(j);
          break;
        }
      }
    }
    // console.log(indexList.sort((a, b) => b - a));
    for (let j = 0; j < indexList.length; j += 1) {
      const componentId = state.panelDataCcg[indexList[j]].cid;
      // console.log(componentId);
      commit('selectCpt', componentId);
      dispatch('deleteNotify', { componentId });
      // state.panelDataCcg.splice(j, 1);
    }
    const data = state.panelDataCcg.filter(item => indexList.indexOf(item.i) === -1);
    // console.log(data);
    state.panelDataCcg = data;
    setTimeout(() => {
      dispatch('saveAllCpt');
    }, 500);
  },
  async deleteNotify({ state }, payload) {
    const { componentId } = payload;
    await request.post(`component/delete/${componentId}`);
  },
  // 保存单个组件信息(只当前传组件的index)
  async saveSingleCpt({ state, commit }, paload) {
    const { index, panelId } = paload;
    const { panelDataCcg } = state;
    const curCpt = panelDataCcg[index];
    const {
      ctype, cid, name, comment, x, y, w, h, zindex, dataSources,
    } = curCpt;
    let d = {
      ctype, cid, name, comment, pos: { x, y }, size: { x: w, y: h }, zindex, dataSources,
    };
    if (ctype === 1) {
      const { enables } = curCpt;
      d = {
        ...d,
        enables,
      };
    } else if (ctype === 3) {
      const { steps } = curCpt;
      d = {
        ...d,
        steps,
      };
    } else if (ctype === 4) {
      const { sendType = COM_SEND_TYPE.NOW, cycleTime } = curCpt;
      d = {
        ...d,
        sendType,
        cycleTime,
      };
    }
    const result = await request.postJson('panel/save', { panelId, components: d })
      .then(res => !!res)
      .catch(() => {
      });
    return result;
  },
  // 保存所有组件数据信息
  async saveAllCpt({ state }, payload) {
    const { panelDataCcg, panelId } = state;
    const data = panelDataCcg.map((item) => {
      const {
        ctype, cid, name, comment, x, y, w, h, zindex,
      } = item;
      let d = {
        ctype, cid, name, comment, pos: { x, y }, size: { x: w, y: h }, zindex,
      };
      if (ctype === COMPONENT_TYPE.Oscillogram) {
        const { enables, dataSources } = item;
        d = {
          ...d,
          enables,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.INPUT) {
        const { steps, dataSources } = item;
        const ds = dataSources.map((item2) => {
          const {
            type, text, key,
          } = item2;
          return {
            key,
            type,
            text,
          };
        });
        d = {
          ...d,
          steps,
          dataSources: ds,
        };
      } else if (ctype === COMPONENT_TYPE.SEND) {
        const { sendType = 0, cycleTime = 1, dataSources } = item;
        d = {
          ...d,
          sendType,
          cycleTime,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.OUTPUT || ctype === COMPONENT_TYPE.MAP || ctype === COMPONENT_TYPE.NUMERICINDICATOR || ctype === COMPONENT_TYPE.CONDITION) {
        const { dataSources } = item;
        const ds = dataSources.map((item2) => {
          const {
            id, type, text, key,
          } = item2;
          return {
            key: id || key,
            type,
            text,
          };
        });
        d = { ...d, dataSources: ds };
      } else if (ctype === COMPONENT_TYPE.DASHBOARD) {
        const { dataSources } = item;
        const ds = dataSources.map((item2) => {
          const {
            id, type, text, key,
          } = item2;
          return {
            key: id || key,
            type,
            text,
          };
        });
        d = { ...d, dataSources: ds };
      } else if (ctype === COMPONENT_TYPE.SWITCHER) {
        const {
          trueValue = 1, falseValue = 0, dataSources = [],
        } = item;
        d = {
          ...d, trueValue, falseValue, dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.UDS || ctype === COMPONENT_TYPE.CUSTOMFRAMES) {
        const { dataSources } = item;
        d = {
          ...d,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.NUMERICCONTROL || ctype === COMPONENT_TYPE.TRIGGER) {
        const { dataSources } = item;
        d = {
          ...d,
          dataSources,
        };
      }
      return d;
    });
    const result = await request.postJson('panel/save', { panelId, components: data })
      .then(() => {
        console.log('保存成功', data);
        // 保存成功后复位面板变化状态
        state.panelChanged = false;
        return true;
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return result;
  },
  // 保存所有组件数据信息
  async StsaveAllCpt({ state, dispatch }, payload) {
    const { panelDataCcg, panelId, panelIdList } = state;
    const data = panelDataCcg.map((item) => {
      const {
        ctype, cid, name, comment, x, y, w, h, zindex,
      } = item;
      let d = {
        ctype, cid, name, comment, pos: { x, y }, size: { x: w, y: h }, zindex,
      };
      if (ctype === COMPONENT_TYPE.Oscillogram) {
        const { enables, dataSources } = item;
        d = {
          ...d,
          enables,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.INPUT) {
        const { steps, dataSources } = item;
        const ds = dataSources.map((item2) => {
          const {
            type, text, key,
          } = item2;
          return {
            key,
            type,
            text,
          };
        });
        d = {
          ...d,
          steps,
          dataSources: ds,
        };
      } else if (ctype === COMPONENT_TYPE.SEND) {
        const { sendType = 0, cycleTime = 1, dataSources } = item;
        d = {
          ...d,
          sendType,
          cycleTime,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.OUTPUT || ctype === COMPONENT_TYPE.MAP || ctype === COMPONENT_TYPE.NUMERICINDICATOR) {
        const { dataSources } = item;
        const ds = dataSources.map((item2) => {
          const {
            id, type, text, key,
          } = item2;
          return {
            key: id || key,
            type,
            text,
          };
        });
        d = { ...d, dataSources: ds };
      } else if (ctype === COMPONENT_TYPE.DASHBOARD) {
        const { dataSources } = item;
        const ds = dataSources.map((item2) => {
          const {
            id, type, text, key,
          } = item2;
          return {
            key: id || key,
            type,
            text,
          };
        });
        d = { ...d, dataSources: ds };
      } else if (ctype === COMPONENT_TYPE.SWITCHER) {
        const {
          trueValue = 1, falseValue = 0, dataSources = [],
        } = item;
        d = {
          ...d, trueValue, falseValue, dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.UDS || ctype === COMPONENT_TYPE.CUSTOMFRAMES) {
        const { dataSources } = item;
        d = {
          ...d,
          dataSources,
        };
      } else if (ctype === COMPONENT_TYPE.NUMERICCONTROL) {
        const { dataSources } = item;
        d = {
          ...d,
          dataSources,
        };
      }
      return d;
    });
    let cnt = 0;
    for (let i = 0; i < panelIdList.length; i += 1) {
      cnt += dispatch('panelsave', { panelId: panelIdList[i], data });
    }
    let result = 0;
    if (cnt === panelIdList.length) {
      result = 1;
    }
    return result;
  },
  async panelsave({ state }, payload) {
    const { panelId, data } = payload;
    await request.postJson('panel/save', { panelId, components: data })
      .then(() => {
        console.log('保存成功');
        // 保存成功后复位面板变化状态
        state.panelChanged = false;
        return true;
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
  },
  // 保存所有组件数据
  // 左侧treedata
  async getLeftStructure({ state, commit }, payload) {
    const { projectId } = payload;
    projectDetailAPI.getDetail(projectId)
      .then((res) => {
        const { structure: { children = [] } = [], panels = [] } = res;
        commit('setLeftStructure', {
          leftStructure: children,
        });
        commit('setPanelList', panels);
        state.displayDetailTabIndex = 0;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  // 通道配置
  settingCan({ commit }, payload) {
    const { id, mode, baudRate, dataBaudRate, canIndex, isPlay } = payload;
    return projectDetailAPI.setCANConfig(id, mode, baudRate, dataBaudRate, canIndex, isPlay)
      .then((res) => {
        if (res) {
          commit('setCANSetting', res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 获取通道配置的波特率
  async getCanConfig({ commit }, payload) {
    await projectDetailAPI.getCANConfig(payload.id)
      .then((res) => {
        if (res) {
          return res;
        }
        return {};
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 获取设备list
  async getDeviceListOptions({ commit }, payload) {
    const { projectId } = payload;
    projectDetailAPI.listDevice(projectId)
      .then((res) => {
        if (res instanceof Array) {
          const tempResultData = res.map(item => ({
            ...item,
            index: item.id,
          }));
          commit('setDeviceListOptions', { deviceListOptions: tempResultData });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 添加设备
  addDevice({ commit, dispatch }, payload) {
    const { projectId, deviceID } = payload;
    return projectDetailAPI.addDevice(projectId, deviceID)
      .then((res) => {
        // 与配置通道的返回时一致的
        dispatch('getLeftStructure', { projectId: payload.projectId });
        // commit('setCANSetting', res);
        return Promise.resolve();
      })
      .catch((err) => {
        console.log(err);
        return Promise.reject(err);
      });
  },
  /**
   * 添加A2L文件
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  async projectAddNodeFile({ commit }, payload) {
    const {
      nodeType, canConfigId, path, projectId,
    } = payload;
    // if (nodeType === PROJECT_NODE_TYPE.DBC_ROOT) {
    //   const requestApi = 'project/can/addDBC';
    // } else if (nodeType === PROJECT_NODE_TYPE.A2L_ROOT) {
    //   let split = path.split('.');
    //   if (split[split.length - 1] === 'zip') {
    //     const requestApi = 'project/can/addA2L';
    //   } else {
    //     const requestApi = 'project/can/addA2lExcel';
    //   }
    // } else {
    //   const requestApi = 'project/can/addUDS';
    // }
    let resultData = null;
    if (nodeType === PROJECT_NODE_TYPE.DBC_ROOT) {
      resultData = await projectDetailAPI.addDBC(canConfigId, path)
        .then((res) => {
          if (res) {
            this.dispatch('Engineering/getLeftStructure', { projectId });
          }
          return true;
        })
        .catch(() => {
        });
    } else if (nodeType === PROJECT_NODE_TYPE.A2L_ROOT) {
      const split = path.split('.');
      if (split[split.length - 1] === 'zip' || split[split.length - 1] === 'a2l') {
        resultData = await projectDetailAPI.addA2L(canConfigId, path)
          .then((res) => {
            if (res) {
              this.dispatch('Engineering/getLeftStructure', { projectId });
            }
            return true;
          })
          .catch(() => {
          });
      } else {
        resultData = await projectDetailAPI.addExcelBindA2L(canConfigId, path)
          .then((res) => {
            if (res) {
              this.dispatch('Engineering/getLeftStructure', { projectId });
            }
            return true;
          })
          .catch(() => {
          });
      }
    } else {
      resultData = await projectDetailAPI.addUDS(canConfigId, path)
        .then((res) => {
          if (res) {
            this.dispatch('Engineering/getLeftStructure', { projectId });
          }
          return true;
        })
        .catch(() => {
        });
    }
    return resultData;
  },
  // 获取a2l的配置数据
  getA2LBindEventData({ commit }, payload) {
    const { canConfigId } = payload;
    return projectDetailAPI.getA2LConfig(payload)
      .then((res) => {
        if (res instanceof Object) {
          const headerArr = res.eventNames;
          const checkArr = res.check;
          commit('setA2LBindEventData', {
            headerArr,
            checkArr,
          });
        }
        return true;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 传递a2l配置数据给后台
  async a2lBindEvent({ commit }, payload) {
    console.log('绑定值', payload);
    const { checkArr, canConfigId } = payload;
    const trueCheckArr = [];
    ((arr = []) => {
      arr.forEach((rowData) => {
        const obj = {};
        Object.entries(rowData)
          .forEach((fieldData) => {
            if (fieldData[1] === true || fieldData[1] === 'true') {
              obj.eventName = fieldData[0];
              obj.measureName = rowData.measureName;
              trueCheckArr.push(obj);
            }
          });
      });
    })(checkArr);
    // 避免造成用户担忧
    if (trueCheckArr.length === 0) {
      return true;
    }
    const result = await projectDetailAPI.bindA2LEvent(canConfigId, trueCheckArr)
      .then(() => true)
      .catch(() => {
      });
    return result;
  },
  // 获取现有的面板(列表)，根据面板panelid来获取面板内部的初始化数据
  async getPanelAllList({ state, commit, dispatch }, payload) {
    const { projectId } = payload;
    commit(Types.SET_PROJETLID, projectId);
    await request.get('panel/list', {
      projectId,
    })
      .then((res) => {
        if (res instanceof Array) {
          // 默认将第一个面板id保存
          commit(Types.SET_CUR_PANELID, res[0].id);
          // 默认获取第一个面板的数据
          dispatch('getInitPanelData', { panelId: res[0].id });
          // 获得工程状态，如果在运行则连接websocket
          dispatch('projectIdStatus', { panelId: res[0].id, projectId });
          // 解决刷新后面板列表有时刷不出来，在之前panel list数据已经和左边树状图同时获得过了
          // const panelList = res.map(item => ({
          //   ...item,
          //   hasStart: false,
          // }));
          // commit('setPanelList', {
          //   panelList,
          // });
        }
      })
      .catch(() => {
      });
  },
  // 增加面板
  async addReportTab({ commit }, payload) {
    const { projectId, panelName } = payload;
    await request.post('panel/add', {
      projectId,
      panelName,
    })
      .then((res) => {
        if (res) {
          commit('addPanel', {
            panel: res,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 面板重命名
  async setReportTabName({ commit }, payload) {
    const { index, name, panelId } = payload;
    const result = await panelApi.rename(panelId, name)
      .then((res) => {
        commit('setReportTabName', {
          index,
          name,
        });
        return true;
      })
      .catch(err => false);
    return result;
  },
  // 删除相应面板
  async deleteReportTab({ commit }, payload) {
    const { panelId, contextMenuIndex } = payload;
    const resultData = await panelApi.deletePanel(panelId)
      .then((res) => {
        // 删除现有的panellist的面板
        commit('deleteDetailPanelTab', {
          panelIndex: contextMenuIndex,
        });
        return true;
      })
      .catch(error => false);
    return resultData;
  },
  // 根据面板id获取初始数据(所有组件数据)
  // 修改：获得当前工程下的所有面板的数据
  async getInitPanelData({ state, commit, dispatch }) {
    commit('clearCpt');
    const { panelId, panelIdList, projectId } = state;
    // for (let i = 0; i < panelIdList.length; i += 1) {
    await panelApi.getComponents(panelId)
      .then((res) => {
        console.log('------');
        console.log(res);
        if (res instanceof Array) {
          commit(Types.SET_PANELDATA_CG, res);
        } else {
          commit(Types.SET_PANELDATA_CG, []);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    dispatch('getCptName');
    dispatch('getCptStyle');
    projectDetailAPI.getBindIni(projectId);
  },
  // 获取自定义组件样式并刷新
  async getCptStyle({ state, commit }) {
    const { panelId, projectId } = state;
    await projectDetailAPI.getCptStyle(projectId, panelId)
      .then((res) => {
        console.log(res);
        commit('setCptStyle', res.componentStyleVos);
      });
    // .finally(() => {
    //   commit('setStyleKey');
    // });
  },
  // 获取自定义组件信号名
  async getCptName({ state, commit }) {
    const { panelId, projectId } = state;
    await projectDetailAPI.getCptName(projectId, panelId)
      .then((res) => {
        // console.log(res);
        commit('setCptSignalName', res);
      });
  },
  // 增加组件
  async addComponent({ commit, dispatch }, payload) {
    const { panelId, type, pos } = payload;
    console.log({
      panelId,
      type,
    })
    const result = await request.post('component/add', {
      panelId,
      type,
    })
      .then((res) => {
        if (res instanceof Object) {
          commit('addComponentForDetailPanel', { res, pos });
          dispatch('saveAllCpt');
          return true;
        }
        return false;
      })
      .catch((err) => {
        console.log(err);
      });
    return result;
  },
  // 保存面板设置，准备请求websocket数据
  async savePanelData({ state, commit }, payload) {
    const { initPanelData, panelId } = payload;
    const result = await request.postJson('panel/save', {
      panelId,
      components: initPanelData,
    })
      .then((res) => {
        if (res) {
          return true;
        }
        return false;
      })
      .catch((err) => {
        console.log(err);
      });
    return result;
  },
  // 原来的以panel为层级启动运行的函数
  // 点击开始，根据panel启动面板的运行
  // startPanel({ state, commit, dispatch }, payload) {
  //   const { that } = payload;
  //   const { panelId, panelDataCcg } = state;
  //   // 清理面板数据
  //   panelDataCcg.forEach((item) => {
  //     item.chartData = [];
  //   });
  //
  //   return panelApi.start(panelId)
  //     .then(() => {
  //       console.debug(`面板开启成功，id=${panelId}, now=${new Date()}`);
  //       // 启动ok的话，则进行面板订阅
  //       dispatch('panelSubscription');
  //       // this.panelSubscription();
  //       return Promise.resolve();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       return Promise.reject(error);
  //     });
  // },
  async getPanelIdList({ commit, dispatch }, payload) {
    const { projectId } = payload;
    await request.get('panel/list', {
      projectId,
    })
      .then((res) => {
        if (res instanceof Array) {
          const panelIdList = res.map(item => item.id);
          commit('setPanelIdList', JSON.stringify(panelIdList));
        }
      })
      .catch(() => {
      });
  },
  // 设置工程状态
  setProjectStatus({ state, commit, dispatch }, payload) {
    const { status } = payload;
    commit(Types.SET_CURPROJECT_STATUS, { type: status });
  },
  // 点击开始，根据panel启动面板的运行
  startProject({ state, commit, dispatch }, payload) {
    const { that, projectId } = payload;
    // 想法是找到panel与project的关系，然后在每个project里处理所有的panel以保证原本的逻辑不变
    const { panelId, panelDataCcg, panelIdList } = state;
    // 清理面板数据
    panelDataCcg.forEach((item) => {
      item.chartData = [];
    });
    return projectApi.start(projectId)
      .then(() => {
        console.debug(`面板开启成功，id=${projectId}, now=${new Date()}`);
        // 启动ok的话，则进行面板订阅
        dispatch('panelSubscription');
        // this.panelSubscription();
        return Promise.resolve();
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error);
      });
  },
  // // 点击关闭
  // stopPanel({ state, commit, dispatch }) {
  //   const panelId = state.panelId;
  //   return panelApi.stop(panelId)
  //     .then(() => {
  //       // 取消订阅
  //       dispatch('panelSubscriptionClose');
  //       commit(Types.SET_CURPANEL_STATUS, { type: false });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // },
  // 点击关闭
  stopProject({ state, commit, dispatch }, payload) {
    const { projectId } = payload;
    return projectApi.stop(projectId)
      .then(() => {
        // 取消订阅
        dispatch('panelSubscriptionClose');
        commit(Types.SET_CURPROJECT_STATUS, { type: false });
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 原来的以panel为层级的订阅
  // /**
  //  * 面板数据订阅
  //  * @param state
  //  * @param rootState
  //  * @param commit
  //  * @param panelId
  //  */
  // panelSubscription({
  //   state, rootState, commit, dispatch,
  // }, payload) {
  //   const { panelId } = state;
  //   // 如果websockets连接成功则开始订阅
  //   if (rootState.App.socketState.isConnected) {
  //     console.log('已连接成功，直接订阅');
  //     const subUrl = websocketApi.panelData(panelId);
  //     state.panelSubscribe = rootState.App.SOCKET.subscribe(subUrl, (msg) => {
  //       console.log('收到推送', JSON.parse(msg.body));
  //       commit('setPanelData', {
  //         message: JSON.parse(msg.body),
  //       });
  //     });
  //     // ack订阅
  //     state.ackSubscribe = rootState.App.SOCKET.subscribe(websocketApi.panelStartAck(panelId), (msg) => {
  //       const body = JSON.parse(msg.body);
  //       console.log('ack推送的body=', body);
  //       if (body.success) {
  //         commit(Types.SET_CURPANEL_STATUS, { type: true });
  //         commit(Types.SET_CAN_STATUS, { data: body.data });
  //         // TODO 通道页状态更新
  //       } else {
  //         commit(Types.SET_CURPANEL_STATUS, { type: false });
  //       }
  //     });
  //     // 所有的通道id
  //     const idList = state.leftStructure.map(item => item.id);
  //     // 订阅每个通道id
  //     idList.forEach((item) => {
  //       const sub = rootState.App.SOCKET.subscribe(websocketApi.canPageStateChanged(item), (msg) => {
  //         console.log('通道订阅推送', msg.body);
  //       });
  //       state.canSubscribe.push(sub);
  //     });
  //     const udsUrl = websocketApi.udsFeedback(panelId);
  //     const udsSub = rootState.App.SOCKET.subscribe(udsUrl, (msg) => {
  //       const udsResult = JSON.parse(msg.body);
  //       console.log('收到UDS推送', udsResult);
  //       commit('addUdsResponse', { udsResult, panelId });
  //     });
  //     state.udsSubscribe.push(udsSub);
  //   } else { // 没有连接成功就往需要执行的方法数组里添加当前事件
  //     console.log('未连接，注册方法');
  //     commit('registerSocketOnConnect', () => {
  //       dispatch('panelSubscription', { panelId });
  //     }, { root: true });
  //   }
  // },
  /**
   * 面板数据订阅
   * @param state
   * @param rootState
   * @param commit
   * @param panelId
   */
  panelSubscription({
    state, rootState, commit, dispatch,
  }, payload) {
    const { panelId, projectId, panelIdList } = state;
    // 如果websockets连接成功则开始订阅
    if (rootState.App.socketState.isConnected) {
      console.log('已连接成功，直接订阅');
      for (let i = 0; i < panelIdList.length; i++) {
        const subUrl = websocketApi.panelData(panelIdList[i]);
        state.panelSubscribe = rootState.App.SOCKET.subscribe(subUrl, (msg) => {
          console.log('收到推送', JSON.parse(msg.body));
          commit('setPanelData', {
            message: JSON.parse(msg.body),
          });
        });
      }
      // console.log(`id为${projectId}`);
      // ack订阅
      state.ackSubscribe = rootState.App.SOCKET.subscribe(websocketApi.projectStartAck(projectId), (msg) => {
        const body = JSON.parse(msg.body);
        console.log('ack推送的body=', body);
        if (body.success) {
          commit(Types.SET_CURPROJECT_STATUS, { type: true });
          commit(Types.SET_CAN_STATUS, { data: body.data });
          // TODO 通道页状态更新
        } else {
          commit(Types.SET_CURPROJECT_STATUS, { type: false });
        }
      });
      // 所有的通道id
      const idList = state.leftStructure.map(item => item.id);
      // 订阅每个通道id
      idList.forEach((item) => {
        const sub = rootState.App.SOCKET.subscribe(websocketApi.canPageStateChanged(item), (msg) => {
          console.log('通道订阅推送', msg.body);
        });
        state.canSubscribe.push(sub);
      });
      const udsUrl = websocketApi.udsFeedback(panelId);
      const udsSub = rootState.App.SOCKET.subscribe(udsUrl, (msg) => {
        const udsResult = JSON.parse(msg.body);
        console.log('收到UDS推送', udsResult);
        commit('addUdsResponse', { udsResult, panelId });
      });
      state.udsSubscribe.push(udsSub);
      //  测试代码
      //  标定初始值订阅
      const iniUrl = websocketApi.bindIniValue(projectId);
      state.bindIniSubscription = rootState.App.SOCKET.subscribe(iniUrl, (msg) => {
        console.log('收到标定量初始值推送', JSON.parse(msg.body));
        commit(Types.SET_CAN_STATUS, { data: [JSON.parse(msg.body)] });
        commit('setBindIniKey');
      });
      //  测试代码
    } else { // 没有连接成功就往需要执行的方法数组里添加当前事件
      console.log('未连接，注册方法');
      commit('registerSocketOnConnect', () => {
        dispatch('panelSubscription', { panelId });
      }, { root: true });
    }
  },
  /**
   * 取消订阅当前面板
   * @param state
   * @param rootState
   * @param commit
   * @param panelId
   */
  panelSubscriptionClose({ state, dispatch }) {
    const { curProjectStatus } = state;
    // 如果当前面板id的状态是打开状态时执行取消
    if (curProjectStatus) {
      // ack订阅取消
      if (state.ackSubscribe) {
        state.ackSubscribe.unsubscribe();
        state.ackSubscribe = null;
      }
      // 面板数据订阅取消
      if (state.panelSubscribe) {
        state.panelSubscribe.unsubscribe();
        state.panelSubscribe = null;
      }
      // 通道状态取消订阅
      if (state.canSubscribe) {
        state.canSubscribe.forEach((value) => {
          value.unsubscribe();
        });
        state.canSubscribe = [];
      }
      // UDS取消订阅
      if (state.udsSubscribe) {
        state.udsSubscribe.forEach((value) => {
          value.unsubscribe();
        });
      }
      //  测试
      // 标定量初始值订阅取消
      if (state.bindIniSubscription) {
        state.bindIniSubscription.unsubscribe();
        state.bindIniSubscription = null;
      }
    }
  },
  /**
   * singleBind 相关action
   *
   *
   *
   */
  async setBindValue({ commit }, payload) {
    const { componentId, datasource, parentKey, value } = payload;
    const re = await projectDetailAPI.setBindValue(componentId, datasource, parentKey, value)
      .then(res => true)
      .catch((err) => {
        console.log(err);
        return false;
      });
    return re;
  },
  switchPageOfCan({ commit }, payload) {
    const { targetPage, id } = payload;
    return projectDetailAPI.switchPage(id, targetPage)
      .then((res) => {
        if (res) {
          commit('switchDetailSingleBind', { targetPage, canId: id });
          return res;
        }
        return res;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  /**
   * 发送组件
   */
  async setSubmitValue({ commit }, payload) {
    const { data, componentId } = payload;
    const result = await request.post('component/send/setValue', {
      data: [data],
      id: componentId,
    })
      .then((res) => {
        if (res) {
          return true;
        }
        return false;
      })
      .catch((err) => {
        console.log(err);
      });
    return result;
  },
  // 发送消息
  async sendSubmitMsg({ state, commit }, payload) {
    const { index, data, times, cycle, nohup } = payload;
    const id = state.panelDataCcg[index].cid;
    const result = await projectDetailAPI.sendSubmitMsg(id, data, times, cycle, nohup)
      .then(res => true)
      .catch((err) => {
        console.log(err);
        return false;
      });
    return result;
  },
  // 停止发送消息
  async stopSendMsg({ state, commit }, payload) {
    const { index, data, times, cycle, nohup } = payload;
    const id = state.panelDataCcg[index].cid;
    const result = await projectDetailAPI.stopSendMsg(id, data, times, cycle, nohup)
      .then(res => true)
      .catch(err => err);
    return result;
  },
  // 保存发送配置
  async saveSendConfig({ state }, payload) {
    const { index, configData, times, cycle, nohup, projectId, messageKey } = payload;
    let dataString = '';
    configData.map((item) => {
      dataString += `${item.name}#`;
      dataString += `${item.value}/`;
    });
    if (dataString.length > 1) {
      dataString = dataString.substring(0, dataString.length - 1);
    }
    const id = state.panelDataCcg[index].cid;
    const result = await panelApi.saveSendConfig(messageKey, projectId, id, cycle, times, nohup, dataString)
      .then(res => true)
      .catch(err => err);
    return result;
  },
  // 获取发送配置
  async getSendConfig({ state }, payload) {
    const index = payload;
    const id = state.panelDataCcg[index].cid;
    const result = await panelApi.getSendConfig(id);
    return result;
  },
  // 获取发送信号值
  async getSendValue({ state }, payload) {
    const projectId = state.projectId;
    const dataSourceId = payload;
    const result = await panelApi.getSendValue(projectId, dataSourceId);
    return result;
  },
  /**
   * 获取当前面板的状态
   * @param commit
   * @param panelId
   * @returns {Promise<void>}
   */
  async panelIdStatus({ commit, dispatch }, { panelId, projectId }) {
    const result = projectDetailAPI.panelIdStatus(panelId)
      .then((res) => {
        if (res instanceof Object) {
          const { type = 0 } = res;
          commit(Types.SET_CURPANEL_STATUS, { type: type === PANEL_STATUS.RUNNING || type === PANEL_STATUS.WAITING });
          // 如果当前面板组件状态是打开，就初始化websockets
          if (type === PANEL_STATUS.RUNNING || type === PANEL_STATUS.WAITING) {
            commit(Types.SET_CURPANEL_STATUS, { type: true });
            dispatch('refreshSubcribe', { panelId, projectId });
          }
        }
        return false;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  /**
   * 获取当前工程的状态
   * @param commit
   * @param projectId
   * @returns {Promise<void>}
   */
  async projectIdStatus({ commit, dispatch }, { panelId, projectId }) {
    const result = projectDetailAPI.projectIdStatus(projectId)
      .then((res) => {
        if (res instanceof Object) {
          const { type = 0 } = res;
          commit(Types.SET_CURPROJECT_STATUS, { type: type === PANEL_STATUS.RUNNING || type === PANEL_STATUS.WAITING });
          // 如果当前面板组件状态是打开，就初始化websockets
          if (type === PANEL_STATUS.RUNNING || type === PANEL_STATUS.WAITING) {
            console.log('进来了');
            commit(Types.SET_CURPROJECT_STATUS, { type: true });
            dispatch('refreshSubcribe', { panelId, projectId });
          }
        }
        return false;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  /**
   * 页面刷新的时候订阅的内容
   * @param state
   * @param dispatch
   * @param commoit
   */
  refreshSubcribe({
    state, dispatch, commit, rootState,
  }, { projectId }) {
    const { panelId, panelIdList } = state;
    if (rootState.App.socketState.isConnected) {
      console.log('已连接成功，直接订阅');
      for (let i = 0; i < panelIdList.length; i += 1) {
        const subUrl = websocketApi.panelData(panelIdList[i]);
        state.panelSubscribe = rootState.App.SOCKET.subscribe(subUrl, (msg) => {
          console.log('收到推送', JSON.parse(msg.body));
          commit('setPanelData', {
            message: JSON.parse(msg.body),
          });
        });
      }
      // 根据工程id获取当前所有通道id状态
      projectDetailAPI.getAllCanStatus(projectId)
        .then((s) => {
          console.log('s');
          console.log(s);
          commit(Types.SET_CAN_STATUS, { data: s });
        })
        .catch((e) => {
          // alert('获取can状态失败');
        });
      // 所有的通道id
      const idList = state.leftStructure.map(item => item.id);
      // 订阅每个通道id
      idList.forEach((item) => {
        const sub = rootState.App.SOCKET.subscribe(websocketApi.canPageStateChanged(item), (msg) => {
          console.log('通道订阅推送', msg.body);
        });
        state.canSubscribe.push(sub);
      });
      // uds相关内容暂时没做改动，wkb
      const udsUrl = websocketApi.udsFeedback(panelId);
      const udsSub = rootState.App.SOCKET.subscribe(udsUrl, (msg) => {
        const udsResult = JSON.parse(msg.body);
        console.log('收到UDS推送', udsResult);
        commit('addUdsResponse', { udsResult, panelId });
      });
      state.udsSubscribe.push(udsSub);
      //  测试代码
      //  标定初始值订阅
      const iniUrl = websocketApi.bindIniValue(projectId);
      state.bindIniSubscription = rootState.App.SOCKET.subscribe(iniUrl, (msg) => {
        console.log('收到标定量初始值推送', JSON.parse(msg.body));
        commit(Types.SET_CAN_STATUS, { data: [JSON.parse(msg.body)] });
        commit('setBindIniKey');
      });
    } else { // 没有连接成功就往需要执行的方法数组里添加当前事件
      console.log('未连接，注册方法');
      commit('registerSocketOnConnect', () => {
        dispatch('refreshSubcribe', { projectId });
      }, { root: true });
    }
  },
  /**
   * 获取左侧树的配置数据
   * @param projectid
   * @returns {*|Promise<any>}
   */
  getTreeConfigData({ state, dispatch, commit }, { projectId }) {
    projectDetailAPI.getTreeConfigData(projectId)
      .then((res) => {
        commit(Types.SET_TREE_CONFIG_DATA, res);
      })
      .catch((error) => {
      });
  },
  /**
   * 保存左侧树的配置数据
   * @param data
   * @returns {*|Promise<any>}
   */
  saveTreeConfigData({ state, dispatch, commit }, data) {
    // if (data.namePrefix === undefined) {
    //   data.namePrefix = '';
    // }
    // console.log(data);
    return projectDetailAPI.saveTreeConfigData(data);
  },
  /**
   * 下载文件下发到设备
   * @param state
   * @param dispatch
   * @param commit
   * @param projectId
   * @param deviceId
   * @returns {*|*|Promise<any>}
   */
  configToDevice({ state, dispatch, commit }, { projectId, deviceId }) {
    return projectDetailAPI.configToDevice(projectId, deviceId);
  },
  /**
   * 移出设备
   * @param state
   * @param dispatch
   * @param commit
   * @param projectId
   * @param deviceId
   * @returns {*|*|Promise<any>}
   */
  deleteDevice({ state, dispatch, commit }, { projectId, deviceId }) {
    return projectDetailAPI.removeDevice(projectId, deviceId);
  },
  /**
   * 进行发送数据的订阅
   */
  async sendSubscription({ state, rootState, commit }, payload) {
    const { projectId } = payload;
    let subList = state.sendSubscription.get(projectId) === undefined ? [] : state.sendSubscription.get(projectId);
    if (rootState.App.socketState.isConnected) {
      // 先取消订阅
      // subList.map((item)=>{
      //   item.unsubscribe()
      // })
      // 进度条添加地方，与websocket建立连接，订阅
      subList = [];
      const ackUrl = websocketApi.sendAck(projectId);
      const sub = rootState.App.SOCKET.subscribe(ackUrl, (msg) => {
        console.log('订阅了');
        console.log(msg);
      });
      subList.push(sub);
      state.sendSubscription.set(projectId, subList);
    }
  },
  /**
   * 取消发送数据的订阅
   */
  async sendUnsubscription({ state, rootState, commit }, payload) {
    const projectId = payload;
    const subList = state.sendSubscription.get(projectId);
    // console.log(state.sendSubscription);
    if (rootState.App.socketState.isConnected) {
      subList.map((item) => {
        item.unsubscribe();
      });
      // console.log('取消订阅');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/engineering/actions.js